<template>
    <div>
        <fluke-card>
            <header v-if="permission.write">
                <div class="title">Editar Post</div>
                <div class="description">Edite as informações do post</div>
            </header>
            <header v-else>
                <div class="title">Visualizar Post</div>
                <div class="description">
                    Alterações desabilitadas para este perfil
                </div>
            </header>
            <fluke-blog-form
                :permission="permission"
                :categories="categories"
                :initial-data="initialData"
                @cancel="cancel"
                @submit="submit"
            ></fluke-blog-form>
        </fluke-card>

        <div class="right" v-if="permission.write">
            <a v-on:click="remove" class="remove-links">Remover Post</a>
        </div>
        <global-popup ref="remove" title="Remover"
            >Deseja remover o post?</global-popup
        >
    </div>
</template>

<script>
import axios from "axios";
import Card from "../../components/Main/Content/Card/Card.vue";
import Button from "../../components/Main/Content/Button/Button.vue";
import Form from "./Form";
import permission from "../../mixins/permissions";
import { postUpdateValidator } from "../../helpers/post_validator";

export default {
    mixins: [permission],
    components: {
        "fluke-card": Card,
        "fluke-button": Button,
        "fluke-blog-form": Form
    },
    data: function() {
        return {
            initialData: null,
            categories: [],
            permission: {
                read: false,
                write: false
            }
        };
    },
    created: function() {
        this.getData();
        this.permission = this.getUserPagePermission("blog");
        if (this.permission.read == false) {
            this.$router.push("/");
        }
    },
    methods: {
        getData: async function() {
            this.id = this.$route.params.id;

            axios
                .get(this.$myServerAddresses.blog + "posts/" + this.id, {
                    headers: {
                        "X-Fluke": this.$cookies.get("token")
                    }
                })
                .then(result => {
                    if (result.data) {
                        this.initialData = {
                            id: this.id,
                            img: result.data.img,
                            title: result.data.title,
                            meta_tags: result.data.meta_tags,
                            meta_description: result.data.meta_description,
                            post: result.data.post,
                            resume: result.data.resume,
                            thumb: result.data.thumb,
                            tags: result.data.tags,
                            selectedCategories: result.data.categories
                        };
                    } else {
                        throw new Error("Post não encontrado");
                    }
                })
                .catch(error => {
                    this.$store.commit("flash_error", error.message);
                    this.$router.push({ name: "blog" });
                });

            axios
                .get(this.$myServerAddresses.blog + "categories", {
                    headers: {
                        "X-Fluke": this.$cookies.get("token")
                    }
                })
                .then(result => {
                    this.categories = result.data;
                });
        },
        submit: async function(data) {
            if (
                data.post.includes('src="data:image/') ||
                data.post.includes("src='data:image/")
            ) {
                alert(
                    "Não colar imagem direto no post, por favor utilize o upload de imagem do editor"
                );
                return;
            }
            let result;
            try {
                await postUpdateValidator(data);
                result = await axios.put(
                    this.$myServerAddresses.blog + "posts",
                    data,
                    {
                        headers: {
                            "X-Fluke": this.$cookies.get("token")
                        }
                    }
                );
                this.$router.push({ name: "blog" });
            } catch (error) {
                this.$store.commit("flash_error", error.message);
            }
        },
        remove: async function() {
            this.$refs.remove.confirm().then(() => {
                axios
                    .delete(this.$myServerAddresses.blog + "posts/" + this.id, {
                        headers: {
                            "X-Fluke": this.$cookies.get("token")
                        }
                    })
                    .then(() => {
                        this.$router.push({ name: "blog" });
                    });
            });
        },
        cancel: function() {
            this.$router.push({ name: "blog" });
        }
    }
};
</script>
